import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
} from "../../util/varios.js";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button.jsx";
import {
  Checkbox,
  Input,
  Radio,
  Select,
  Textarea,
} from "../../ui/inputs/Input.jsx";
import CatalogoAllCuentasContables from "../../catalogos/catalogoCtaconta2.js";

export const GestionarCuentasBancarias = (props) => {
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");
  let idorganizacion = JSON.parse(localStorage.getItem("idorganizacion"));
  let idefiscal = JSON.parse(localStorage.getItem("idefiscal")) || 1;

  // Refs
  const txtId = useRef();
  const cmbTipo = useRef();
  const chkSi = useRef();
  const chkNo = useRef();
  const chkDepositos = useRef();
  const txtNombre = useRef();
  const txtNCuenta = useRef();
  const txtSucursal = useRef();
  const txtPersona = useRef();
  const txtTelefono = useRef();
  const txtPrepuesto = useRef();
  const txtDireccion = useRef();
  const txtSaldoCon = useRef();
  const txtSaldoLib = useRef();
  const txtConcepto = useRef();
  const txtPorcenDeb = useRef();
  const txtEmision = useRef();
  const txtCtaContable = useRef();
  const txtCodCtaContable = useRef();
  const txtCtaContableNota = useRef();
  const txtCodCtaContableNota = useRef();
  const txtCtaContableTransf = useRef();
  const txtCodCtaContableTransf = useRef();
  const cmbStatus = useRef();

  // States
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [bancos, setBancos] = useState([]);
  const [cuentasContables, setCuentasContables] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [idBanco, setIdBanco] = useState();

  // Estados para los catálogos
  const [showCatalogoCuentaPrincipal, setShowCatalogoCuentaPrincipal] = useState(false);
  const [showCatalogoCuentaNota, setShowCatalogoCuentaNota] = useState(false);
  const [showCatalogoCuentaTransf, setShowCatalogoCuentaTransf] = useState(false);
  const [tipoCatalogoActual, setTipoCatalogoActual] = useState(null); // 0: principal, 1: nota, 2: transf

  const [values, setValues] = useState({
    idcuentabancaria: "",
    nombre: "",
    cuentabancaria: "",
    sucursal: "",
    direccion: "",
    contacto: "",
    telefono: "",
    presupuesto: "",
    saldoconcil: "0,00",
    saldolib: "0,00",
    codctacont: "",
    tipo: "",
    concepto: "",
    debitobanc: true,
    porcentdebito: "0,00",
    codctadebitobanc: "",
    idorganizacion: "",
    idefiscal: "",
    idbanco: "",
    caduca: "60",
    idcuentacontable: "",
    depositoweb: false,
    status: "1",
    idcuentacontablenota: "",
    idcuentacontabletransf: "",
    codctacontablenota: "",
    codctacontabletransf: "",
  });

  const styleInput = {
    height: "100%",
    textOverflow: "ellipsis",
  };

  // Handlers
  const onChange = (event) => {
    const excludedFields = ["direccion", "sucursal", "contacto", "concepto"];
    let value = event.target.value;

    if (excludedFields.includes(event.target.name)) {
      value = value.toUpperCase();
    }

    setValues({ ...values, [event.target.name]: value });
  };

  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      setValues({ ...values, [event.target.name]: event.target.value });
    }
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    let value = event.target.value;

    if (value === "" || parseFloat(value.replace(/\./g, "").replace(",", ".")) === 0.0) {
      value = "0,00";
    }

    if (event.which === 13 || typeof event.which === "undefined") {
      value = formatoMonto(value);
      let char1 = value.substring(0, 1);
      let char2 = value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        value = value.substring(1);
      }
      event.target.value = value;
      setValues({ ...values, [event.target.name]: value });
    }
  };

  const seleccionarCuentaContable = async (item, tipo) => {

    setActivate(true);

    if (item.cargable) {
      const codigoCuenta = item.codigocuenta;
      if (tipo === 0) {
        setValues(prev => ({ ...prev, codctacont: codigoCuenta }));
        if (txtCtaContable.current) txtCtaContable.current.value = codigoCuenta;
      } else if (tipo === 1) {
        setValues(prev => ({ ...prev, codctacontablenota: codigoCuenta }));
        if (txtCtaContableNota.current) txtCtaContableNota.current.value = codigoCuenta;
      } else if (tipo === 2) {
        setValues(prev => ({ ...prev, codctacontabletransf: codigoCuenta }));
        if (txtCtaContableTransf.current) txtCtaContableTransf.current.value = codigoCuenta;
      }
      setActivate(false);
      return true;

    } else {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "LA CUENTA ES NO CARGABLE",
        icono: "informacion",
      });
      setActivate(false);
      return false;
    }
  };

  // Función para abrir el catálogo
  const abrirCatalogoCuentas = (tipo) => {
    setTipoCatalogoActual(tipo);
    if (tipo === 0) {
      setShowCatalogoCuentaPrincipal(true);
    } else if (tipo === 1) {
      setShowCatalogoCuentaNota(true);
    } else if (tipo === 2) {
      setShowCatalogoCuentaTransf(true);
    }
  };

  // Función para manejar la selección del catálogo
  const handleSeleccionCuentaContable = async (cuentaSeleccionada) => {
    if (!cuentaSeleccionada || !cuentaSeleccionada.idplancuenta) return;

    const idCuenta = cuentaSeleccionada.idplancuenta;

    if (tipoCatalogoActual === 0) {
      setValues(prev => ({ ...prev, idcuentacontable: idCuenta }));
      if (txtCodCtaContable.current) txtCodCtaContable.current.value = idCuenta;
      await seleccionarCuentaContable(cuentaSeleccionada, 0);
      setShowCatalogoCuentaPrincipal(false);
    } else if (tipoCatalogoActual === 1) {
      setValues(prev => ({ ...prev, idcuentacontablenota: idCuenta }));
      if (txtCodCtaContableNota.current) txtCodCtaContableNota.current.value = idCuenta;
      await seleccionarCuentaContable(cuentaSeleccionada, 1);
      setShowCatalogoCuentaNota(false);
    } else if (tipoCatalogoActual === 2) {
      setValues(prev => ({ ...prev, idcuentacontabletransf: idCuenta }));
      if (txtCodCtaContableTransf.current) txtCodCtaContableTransf.current.value = idCuenta;
      await seleccionarCuentaContable(cuentaSeleccionada, 2);
      setShowCatalogoCuentaTransf(false);
    }

    setTipoCatalogoActual(null);
  };

  const procesarRegistro = async () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/administracion/actualizarcuentabancaria`;

    // Convertir montos
    const saldoConcil = txtSaldoCon.current?.value || "0,00";
    const saldoLib = txtSaldoLib.current?.value || "0,00";
    const porcentDeb = txtPorcenDeb.current?.value || "0,00";

    let body = {
      operacion: operacion,
      nid: values.idcuentabancaria !== "" ? parseInt(values.idcuentabancaria) : 0,
      nombanc: values.nombre?.trim() || "",
      nrocuent: values.cuentabancaria?.trim() || "",
      sucur: values.sucursal?.trim().toUpperCase() || "",
      dir: values.direccion?.trim().toUpperCase() || "",
      cont: values.contacto?.trim().toUpperCase() || "",
      telf: values.telefono?.trim() || "",
      presu: values.presupuesto?.trim() || "No",
      salconc: parseFloat(saldoConcil.replace(/\./g, "").replace(",", ".")) || 0,
      sallib: parseFloat(saldoLib.replace(/\./g, "").replace(",", ".")) || 0,
      ctacont: values.idcuentacontable !== "0" && values.idcuentacontable !== "" ? parseInt(values.idcuentacontable) : null,
      tip: values.tipo?.trim() || "",
      concep: values.concepto?.trim().toUpperCase() || "",
      impdeb: chkSi.current?.checked || false,
      porc: parseFloat(porcentDeb.replace(/\./g, "").replace(",", ".")) || 0,
      ctacontdeb: null,
      org: operacion === 1 ? idorganizacion : values.idorganizacion,
      efis: idefiscal,
      idban: parseInt(idBanco),
      cadu: values.caduca === "" ? 60 : parseInt(values.caduca),
      idcta: values.idcuentacontable !== "0" && values.idcuentacontable !== "" ? parseInt(values.idcuentacontable) : null,
      depweb: chkDepositos.current?.checked || false,
      idctanota: values.idcuentacontablenota !== "0" && values.idcuentacontablenota !== "" ? parseInt(values.idcuentacontablenota) : null,
      idctatransfe: values.idcuentacontabletransf !== "0" && values.idcuentacontabletransf !== "" ? parseInt(values.idcuentacontabletransf) : null,
      status: cmbStatus.current?.value ? parseInt(cmbStatus.current.value) : 1,
    };

    try {
      const response = await axios.post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        let texto = "";
        switch (operacion) {
          case 1: texto = "registro creado correctamente"; break;
          case 2: texto = "registro modificado correctamente"; break;
          case 3: texto = "registro eliminado correctamente"; break;
          default: texto = "operación completada correctamente";
        }
        setMensaje({
          mostrar: true,
          titulo: "Éxito",
          texto: texto,
          icono: "exito",
        });
      }
    } catch (error) {
      let mensajeError = "";
      if (error.response === undefined) {
        mensajeError = "Error de Conexión";
      } else {
        mensajeError = error.response.data?.message || "Error al procesar la operación";
      }
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: mensajeError,
        icono: "error",
      });
    } finally {
      setActivate(false);
    }
  };

  const blanquear = () => {
    setValues({
      idcuentabancaria: "",
      nombre: "",
      cuentabancaria: "",
      sucursal: "",
      direccion: "",
      contacto: "",
      telefono: "",
      presupuesto: "",
      saldoconcil: "0,00",
      saldolib: "0,00",
      codctacont: "",
      tipo: "",
      concepto: "",
      debitobanc: true,
      porcentdebito: "0,00",
      codctadebitobanc: "",
      idorganizacion: "",
      idefiscal: "",
      idbanco: "",
      caduca: "60",
      idcuentacontable: "",
      depositoweb: false,
      status: "1",
      idcuentacontablenota: "",
      idcuentacontabletransf: "",
      codctacontablenota: "",
      codctacontabletransf: "",
    });
    if (txtSaldoCon.current) txtSaldoCon.current.value = "0,00";
    if (txtSaldoLib.current) txtSaldoLib.current.value = "0,00";
    if (txtPorcenDeb.current) txtPorcenDeb.current.value = "0,00";
    if (txtCodCtaContable.current) txtCodCtaContable.current.value = "";
    if (txtCtaContable.current) txtCtaContable.current.value = "";
    if (txtCodCtaContableNota.current) txtCodCtaContableNota.current.value = "";
    if (txtCtaContableNota.current) txtCtaContableNota.current.value = "";
    if (txtCodCtaContableTransf.current) txtCodCtaContableTransf.current.value = "";
    if (txtCtaContableTransf.current) txtCtaContableTransf.current.value = "";
  };

  const seleccionarBancos = async () => {
    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=*&nomtab=bancos&orden=idbanco`;
    setActivate(true);

    try {
      const response = await axios.get(endpoint, {
        headers: { "x-access-token": `${token}` },
      });

      if (response.status === 200) {
        const newBancosList = response.data.map((banco) => ({
          value: banco.idbanco,
          label: banco.nombre,
        }));
        setBancos(newBancosList);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response?.data?.message || "Error al cargar bancos",
        icono: "error",
      });
    } finally {
      setActivate(false);
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const idbancio = (id) => (e) => {
    e.preventDefault();
    setIdBanco(id);
    setValues(prev => ({ ...prev, idbanco: id }));
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  const onChangeValidar = () => {
    let sigue = true;
    const camposRequeridos = [
      { campo: cmbTipo.current?.value, nombre: "el Tipo", ref: cmbTipo },
      { campo: values.nombre, nombre: "el Nombre del Banco", ref: txtNombre },
      { campo: values.cuentabancaria, nombre: "la Cuenta", ref: txtNCuenta },
      { campo: values.sucursal, nombre: "la Sucursal", ref: txtSucursal },
      { campo: values.contacto, nombre: "la Persona de Contacto", ref: txtPersona },
      { campo: values.direccion, nombre: "la Dirección", ref: txtDireccion },
      { campo: values.saldoconcil, nombre: "el Saldo Conciliado", ref: txtSaldoCon },
      { campo: values.saldolib, nombre: "Saldo en Libros", ref: txtSaldoLib },
      { campo: values.concepto, nombre: "Concepto", ref: txtConcepto },
    ];

    for (let item of camposRequeridos) {
      if (!item.campo || item.campo === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: `Debe Ingresar Correctamente ${item.nombre}.`,
          icono: "informacion",
        });
        if (item.ref.current) item.ref.current.focus();
        sigue = false;
        break;
      }
    }

    if (sigue && chkSi.current?.checked) {
      const porcentaje = values.porcentdebito?.replace(/\./g, "").replace(",", ".") || "0";
      if (parseFloat(porcentaje) === 0) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "El porcentaje de débito bancario no puede ser cero",
          icono: "informacion",
        });
        if (txtPorcenDeb.current) txtPorcenDeb.current.focus();
        sigue = false;
      }
    }

    if (sigue) {
      let msg = "";
      switch (operacion) {
        case 1: msg = "¿Está Seguro de Registrar estos Datos?"; break;
        case 2: msg = "¿Está Seguro de Modificar estos Datos?"; break;
        case 3: msg = "¿Está Seguro de Eliminar estos Datos?"; break;
        default: msg = "¿Está Seguro de continuar?";
      }
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const cerrarModal = () => {
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  useEffect(() => {
    seleccionarBancos();
  }, []);

  useEffect(() => {
    setOperacion(props.operacion);
    if (props.operacion !== 1 && props.bancos) {
      setIdBanco(props.bancos.idbanco);
      setValues(prev => ({ ...prev, ...props.bancos }));

      // Formatear valores monetarios
      if (props.bancos.saldolib) {
        const formattedLib = formatMoneda(props.bancos.saldolib.replace(",", "").replace(".", ","), ",", ".", 2);
        if (txtSaldoLib.current) txtSaldoLib.current.value = formattedLib;
      }
      if (props.bancos.saldoconcil) {
        const formattedCon = formatMoneda(props.bancos.saldoconcil.replace(",", "").replace(".", ","), ",", ".", 2);
        if (txtSaldoCon.current) txtSaldoCon.current.value = formattedCon;
      }
      if (props.bancos.porcentdebito) {
        const formattedPorc = formatMoneda(props.bancos.porcentdebito.replace(",", "").replace(".", ","), ",", ".", 2);
        if (txtPorcenDeb.current) txtPorcenDeb.current.value = formattedPorc;
      }

      // Configurar radios
      if (chkSi.current && chkNo.current) {
        if (props.bancos.debitobanc) {
          chkSi.current.checked = true;
          chkNo.current.checked = false;
        } else {
          chkSi.current.checked = false;
          chkNo.current.checked = true;
        }
      }

      if (chkDepositos.current) {
        chkDepositos.current.checked = props.bancos.depositoweb || false;
      }

      // Establecer valores de los códigos de cuenta
      if (txtCodCtaContable.current && props.bancos.idcuentacontable) {
        txtCodCtaContable.current.value = props.bancos.idcuentacontable;
      }
      if (txtCodCtaContableNota.current && props.bancos.idcuentacontablenota) {
        txtCodCtaContableNota.current.value = props.bancos.idcuentacontablenota;
      }
      if (txtCodCtaContableTransf.current && props.bancos.idcuentacontabletransf) {
        txtCodCtaContableTransf.current.value = props.bancos.idcuentacontabletransf;
      }

      // Cargar cuentas contables relacionadas
      if (props.bancos.idcuentacontable && props.bancos.idcuentacontable !== "0") {
        seleccionarCuentaContable(props.bancos.idcuentacontable, 0);
      }
      if (props.bancos.idcuentacontablenota && props.bancos.idcuentacontablenota !== "0") {
        seleccionarCuentaContable(props.bancos.idcuentacontablenota, 1);
      }
      if (props.bancos.idcuentacontabletransf && props.bancos.idcuentacontabletransf !== "0") {
        seleccionarCuentaContable(props.bancos.idcuentacontabletransf, 2);
      }
    } else if (props.operacion === 1) {
      if (chkSi.current) chkSi.current.checked = true;
      if (chkNo.current) chkNo.current.checked = false;
    }
  }, [props.operacion, props.bancos]);

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="header-azulGradiant">
          <h3>
            {props.operacion === 1
              ? "Agregar Cuenta Bancaria"
              : props.operacion === 2
                ? "Editar Cuenta Bancaria"
                : props.operacion === 3
                  ? "Eliminar Cuenta Bancaria"
                  : "Consultar Cuenta Bancaria"}
          </h3>
          <a type="button" onClick={cancelar}>
            salir <i className="fa fa-times"></i>
          </a>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "450px" }} className="overflow-auto">
          <Mensaje
            mensaje={mensaje}
            onHide={() => {
              mensaje.titulo === "Éxito"
                ? cerrarModal()
                : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
            }}
          />
          <MensajeSiNo
            mensaje={mensajesino}
            onHideNo={() =>
              setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
            }
            onHideSi={handleCloseSi}
          />
          <Dimmer active={activate} inverted />

          <div className="col-12 d-flex flex-col flex-lg-row flex-lg-wrap m-0 p-0">
            {props.operacion !== 1 && (
              <div className="col-2 m-0 mb-2 p-0">
                <Input
                  label="Código:"
                  name="idcuentabancaria"
                  value={values.idcuentabancaria}
                  disabled
                  ref={txtId}
                />
              </div>
            )}
            <div className="d-none col-10 d-lg-block"></div>

            {/* Nombre del Banco */}
            <div className="col-12 m-0 mb-2 p-0">
              <Select
                label="Nombre del Banco:"
                disabled={operacion === 1 || operacion === 2 ? false : true}
                ref={txtNombre}
                className="form-select bg-light"
                name="nombre"
                onChange={(e) => {
                  onChange(e);
                  const selected = bancos.find(b => b.label === e.target.value);
                  if (selected) idbancio(selected.value)(e);
                }}
                value={values.nombre || ""}
                options={bancos}
              />
            </div>

            {/* Número de Cuenta */}
            <div className="col-12 col-lg-6 m-0 mb-2 p-0">
              <Input
                label="N° de Cuenta:"
                name="cuentabancaria"
                maxLength={20}
                value={values.cuentabancaria || ""}
                disabled={operacion === 1 || operacion === 2 ? false : true}
                onChange={onChange}
                onKeyUp={handleInputNumChange}
                onBlur={handleInputNumChange}
                ref={txtNCuenta}
              />
            </div>

            {/* Tipo */}
            <div className="col-12 col-lg-6 m-0 mb-2 p-0 pl-lg-2">
              <Select
                label="Tipo:"
                disabled={operacion === 1 || operacion === 2 ? false : true}
                name="tipo"
                onChange={onChange}
                value={values.tipo || ""}
                ref={cmbTipo}
                options={[
                  { value: "", label: "Seleccione" },
                  { value: "Ingresos Propios", label: "Ingresos Propios" },
                  { value: "Situado Constitucional", label: "Situado Constitucional" },
                  { value: "Ejidos", label: "Ejidos" },
                  { value: "Nómina", label: "Nómina" },
                  { value: "Gastos de Inversión", label: "Gastos de Inversión" },
                  { value: "Fondos a Terceros", label: "Fondos a Terceros" },
                  { value: "Otros", label: "Otros" },
                ]}
              />
            </div>

            {/* Status */}
            <div className="col-12 col-lg-6 m-0 mb-2 p-0">
              <Select
                label="Status:"
                disabled={operacion === 1 || operacion === 2 ? false : true}
                name="status"
                onChange={onChange}
                value={values.status === "1" ? "Activo" : values.status === "2" ? "Inactivo" : values.status}
                ref={cmbStatus}
                options={[
                  { value: "1", label: "Activo" },
                  { value: "2", label: "Inactivo" },
                ]}
              />
            </div>

            {/* Sucursal */}
            <div className="col-12 col-lg-6 m-0 mb-2 p-0">
              <Input
                label="Sucursal:"
                name="sucursal"
                value={values.sucursal || ""}
                disabled={operacion === 1 || operacion === 2 ? false : true}
                onChange={onChange}
                ref={txtSucursal}
              />
            </div>

            {/* Persona de Contacto */}
            <div className="col-12 m-0 mb-2 p-0">
              <Input
                label="Persona de Contacto:"
                name="contacto"
                value={values.contacto || ""}
                disabled={operacion === 1 || operacion === 2 ? false : true}
                onChange={onChange}
                ref={txtPersona}
              />
            </div>

            {/* Teléfono */}
            <div className="col-12 col-lg-6 m-0 mb-2 p-0">
              <Input
                label="Teléfono:"
                name="telefono"
                value={values.telefono || ""}
                disabled={operacion === 1 || operacion === 2 ? false : true}
                onChange={onChange}
                onKeyUp={handleInputNumChange}
                ref={txtTelefono}
              />
            </div>

            {/* Presupuesto */}
            <div className="col-12 col-lg-6 m-0 mb-2 p-0">
              <Select
                label="Presupuesto:"
                disabled={operacion === 1 || operacion === 2 ? false : true}
                name="presupuesto"
                onChange={onChange}
                value={values.presupuesto || "No"}
                ref={txtPrepuesto}
                options={[
                  { value: "Si", label: "Si" },
                  { value: "No", label: "No" },
                ]}
              />
            </div>

            {/* Dirección */}
            <div className="col-12 m-0 mb-2 p-0">
              <Textarea
                label="Dirección:"
                disabled={operacion === 1 || operacion === 2 ? false : true}
                value={values.direccion || ""}
                name="direccion"
                onChange={onChange}
                ref={txtDireccion}
              />
            </div>

            <div class="input-group input-group-sm mb-2 px-0 col-md-12">
              <span class="input-group-text" id="inputGroup-sizing-sm">Código Cuenta Contable:</span>
              <input type="text"
                name="idcuentacontable"
                value={values.idcuentacontable || ""}
                disabled
                onChange={onChange}
                onKeyUp={(e) => {
                  if (e.key === 'Enter') {
                    seleccionarCuentaContable(values.idcuentacontable, 0);
                  }
                }}
                ref={txtCodCtaContable}
                class="form-control col-md-1" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
              <button
                type="button"
                className="btn btn-info"
                disabled={operacion !== 1 && operacion !== 2}
                onClick={() => abrirCatalogoCuentas(0)}
              >
                <i className="fa fa-search"></i>
              </button>
              <input type="text"
                name="codctacont"
                value={values.codctacont || ""}
                disabled
                ref={txtCtaContable}
                class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

            </div>

         {/*    <div class="input-group input-group-sm mb-2 px-0 col-md-12">
              <span class="input-group-text" id="inputGroup-sizing-sm">Código Cuenta Nota de Crédito:</span>
              <input type="text"
                name="idcuentacontablenota"
                value={values.idcuentacontablenota || ""}
                disabled
                onChange={onChange}
                onKeyUp={(e) => {
                  if (e.key === 'Enter') {
                    seleccionarCuentaContable(values.idcuentacontablenota, 1);
                  }
                }}
                ref={txtCodCtaContableNota}
                class="form-control col-md-1" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
              <button
                type="button"
                className="btn btn-info"
                disabled={operacion !== 1 && operacion !== 2}
                onClick={() => abrirCatalogoCuentas(1)}
              >
                <i className="fa fa-search"></i>
              </button>
              <input type="text"
                name="codctacontablenota"
                value={values.codctacontablenota || ""}
                disabled
                ref={txtCtaContableNota}
                class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

            </div>

            <div class="input-group input-group-sm mb-2 px-0 col-md-12">
              <span class="input-group-text" id="inputGroup-sizing-sm">Código Cuenta Transferencia:</span>
              <input type="text"
               name="idcuentacontabletransf"
                  value={values.idcuentacontabletransf || ""}
                  disabled
                  onChange={onChange}
                  onKeyUp={(e) => {
                    if (e.key === 'Enter') {
                      seleccionarCuentaContable(values.idcuentacontabletransf, 2);
                    }
                  }}
                  ref={txtCodCtaContableTransf}
                class="form-control col-md-1" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
              <button
                type="button"
                className="btn btn-info"
                disabled={operacion !== 1 && operacion !== 2}
                onClick={() => abrirCatalogoCuentas(2)}
              >
                <i className="fa fa-search"></i>
              </button>
              <input type="text"
                 name="codctacontabletransf"
                value={values.codctacontabletransf || ""}
                disabled
                ref={txtCtaContableTransf}
                class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

            </div> */}



            {/* Concepto */}
            <div className="col-12 m-0 mb-2 p-0">
              <Input
                label="Concepto:"
                name="concepto"
                value={values.concepto || ""}
                disabled={operacion === 1 || operacion === 2 ? false : true}
                onChange={onChange}
                ref={txtConcepto}
              />
            </div>

            {/* Saldos */}
            <div className="col-12 m-0 p-0 d-flex flex-wrap justify-content-between gap-2">
              <div className="col-5 col-lg-3 m-0 p-0">
                <Input
                  label="Saldo Conciliado:"
                  align="right"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  onChange={onChange}
                  name="saldoconcil"
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                  value={values.saldoconcil || "0,00"}
                  ref={txtSaldoCon}
                />
              </div>
              <div className="col-5 col-lg-3 m-0 p-0">
                <Input
                  label="Saldo en Libros:"
                  name="saldolib"
                  align="right"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  onChange={onChange}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                  value={values.saldolib || "0,00"}
                  ref={txtSaldoLib}
                />
              </div>
              <div className="col-8 col-lg-5 m-0 p-0">
                <Input
                  label="Porcentaje Débito Bancario:"
                  name="porcentdebito"
                  align="right"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  onChange={onChange}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                  value={values.porcentdebito || "0,00"}
                  ref={txtPorcenDeb}
                />
              </div>
            </div>

            {/* Impuesto Débito Bancario */}
            <div className="col-12 d-flex m-0 my-2 p-0">
              <label className="m-0 mr-2 p-0">Impuesto del Débito Bancario:</label>
              <div className="m-0 mr-2 p-0">
                <Radio
                  label="Si"
                  name="debitobanc"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  id="flexRadioDefault1"
                  value="true"
                  checked={chkSi.current?.checked}
                  onChange={() => {
                    if (chkSi.current) chkSi.current.checked = true;
                    if (chkNo.current) chkNo.current.checked = false;
                    setValues(prev => ({ ...prev, debitobanc: true }));
                  }}
                  ref={chkSi}
                />
              </div>
              <div className="m-0 p-0">
                <Radio
                  label="No"
                  name="debitobanc"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  id="flexRadioDefault2"
                  value="false"
                  checked={chkNo.current?.checked}
                  onChange={() => {
                    if (chkSi.current) chkSi.current.checked = false;
                    if (chkNo.current) chkNo.current.checked = true;
                    setValues(prev => ({ ...prev, debitobanc: false }));
                  }}
                  ref={chkNo}
                />
              </div>
            </div>

            {/* Depósitos Caja */}
            <Checkbox
              label="Depósitos Caja:"
              id="flexCheckDefault"
              disabled={operacion === 1 || operacion === 2 ? false : true}
              onChange={(e) => {
                setValues(prev => ({ ...prev, depositoweb: e.target.checked }));
              }}
              checked={values.depositoweb || false}
              ref={chkDepositos}
            />

            {/* Emisión de Cheques */}
            <div className="col-12 m-0 mb-2 p-0">
              <Input
                label="Emisión de Cheque Caduca a los:"
                name="caduca"
                value={values.caduca || "60"}
                disabled={operacion === 1 || operacion === 2 ? false : true}
                onChange={onChange}
                onKeyUp={handleInputNumChange}
                ref={txtEmision}
                appendLabel="Días"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="footer-azulGradiant">
          <SuccessButton
            onClick={onChangeValidar}
            disabled={operacion === 4 ? true : false}
          >
            Aceptar
          </SuccessButton>
          <DangerButton onClick={cancelar}>Cancelar</DangerButton>
        </Modal.Footer>
      </Modal>

      {/* Catálogos de Cuentas Contables */}
      <CatalogoAllCuentasContables
        show={showCatalogoCuentaPrincipal}
        onHideCancelar={() => setShowCatalogoCuentaPrincipal(false)}
        onHideAceptaCatalogo={handleSeleccionCuentaContable}
      />

      <CatalogoAllCuentasContables
        show={showCatalogoCuentaNota}
        onHideCancelar={() => setShowCatalogoCuentaNota(false)}
        onHideAceptaCatalogo={handleSeleccionCuentaContable}
      />

      <CatalogoAllCuentasContables
        show={showCatalogoCuentaTransf}
        onHideCancelar={() => setShowCatalogoCuentaTransf(false)}
        onHideAceptaCatalogo={handleSeleccionCuentaContable}
      />
    </>
  );
};